import { AnimatePresence } from "framer-motion";
import React, { useEffect, useState } from "react";
import CryptoJS from "crypto-js";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { NotificationModul, ModalSwitch, Toast, Cart } from "../Components";
import { campaignService, searchProfileService } from "../Services";
import { PrivateRoute } from "../Helpers";
import { storageHandler } from "../Helpers";
import {
  Billing,
  BrandProfile,
  Assets,
  BrandDashboard,
  Campaigns,
  ProductGuidelines,
  Recommend,
  SearchInf,
  InfluencerList,
  Pricing,
  InfluencerProfile,
  Offer,
  OrderDetails,
  Order,
  Report,
  PlaceOrder,
  BrandReview,
  Chat,
  Briefing,
  Owl,
  JobCampaigns,
  CampaignApplication,
} from "./index";
import JobPostMain from "./JobCampaigns/JobCampaignsCreate/JobPostMain";
import ProjectDescription from "./JobCampaigns/JobCampaignsCreate/ProjectDescription";
import BriefFormWrapper from "./JobCampaigns/JobCampaignsCreate/BriefFormWrapper";
import { InfoPage1 } from "../Components/InfoPage1";
import AppLayout from "../Components/Layout/AppLayout";
import { BrandTamaCoin } from "./BrandTamaCoin";
import { FraudDetectionTools } from "./FraudDetectionTools/FraudDetectionTools";
import BrandPage from "./Brandpage/BrandPage";

export default function Brand({
  user,
  userInfo,
  setChangePage,
  changePage,
  path,
  allNotifications,
  setModalNotification,
  setModalNotificationData,
  updateNotificationStatus,
  accountCount,
  locationData,
  impersonationBar,
  handleAnchorClick,
  setSaveCampaign,
  setShowConfirmModal,
  setShowConfirmAction,
  saveCampaign,
}) {
  // console.log(NotificationModul);
  const secretKey = process.env.REACT_APP_SECRET_KEY;
  const [NotifModul, setNotifModul] = useState(NotificationModul);
  const [modal, setModal] = useState(null);
  const [menu, setMenu] = useState(false);
  const [profiles, setProfiles] = useState([]);
  const location = useLocation();
  const [toastList, setToastList] = useState([]);
  const [totalToPay, setTotalToPay] = useState();
  const [showCart, setShowCart] = useState(false);
  const [cartItem, setCartItem] = useState([]);
  const [closeCartFirsttime, setCloseCartFirsttime] = useState(true);
  const navigate = useNavigate();
  const [newNavigation, setNewNavigation] = useState({});
  const [availableBalance, setAvailableBalance] = useState(0);
  const [isAvailableBalnceLoaded, setIsAvailableBalnceLoaded] = useState(false);
  const [subTotalAmt, setSubTotalAmt] = useState(0);
  const [orderCreated, setOrderCreated] = useState(false);
  const [userTypeRegOrNon, setUserTypeRegOrNon] = useState();
  const [updateProfilePage, setUpdateProfilePage] = useState(true);
  const [paypalAmt, setPaypalAmt] = useState(0);
  const [offerSelectedForReview, setOfferSelectedForReview] = useState(null);
  const [chatInfo, setChatInfo] = useState(null);
  const [customTitle, setCustomTitle] = useState(null);

  useEffect(() => {
    if (user) {
      const rolesWithActive = user?.data?.roles?.map((role) => ({
        ...role,
        active: role.id === user?.data?.active_role ? 1 : 0,
      }));
      setProfiles(rolesWithActive);
      const roleId =
        user["data"]["roles"]?.length > 0
          ? user["data"]["roles"]?.filter(
              (item) => item["id"] === user["data"]["active_role"]
            )[0]["id"]
          : "";
      if (roleId === 1) {
        //navigate('/influencer/dashboard');
      } else if (roleId === 2) {
        //navigate('/admin/dashboard');
      }
    }
  }, [user]);

  useEffect(() => {
    async function fetchBalance() {
      try {
        const res = await searchProfileService.getBalance();
        setAvailableBalance(
          parseFloat(res.wallet_details.available.replace(/[\$,]/g, ""))
        );
        setIsAvailableBalnceLoaded(true);
      } catch (err) {
        console.error("Balance fetch error:", err);
        setIsAvailableBalnceLoaded(true); // Set to true to prevent blocking UI
        // addToast({
        //   error: true,
        //   msg: err.message || "Failed to fetch balance",
        //   id: `${Date.now()}-${toastList.length}`,
        // });
      }
    }
    fetchBalance();
  }, [showCart, cartItem]);
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };
  useEffect(() => {
    if (modal) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modal]);
  const deleteNotif = (id) => {
    setNotifModul(NotifModul.filter((item) => item.id !== id));
    if (modal === "notifDelete") {
      setModal("notifications");
    } else if (modal === "notifDeleteDash") {
      setModal(null);
    }
  };
  const leaveCampaign = () => {
    //console.log("dsd")
  };
  useEffect(() => {
    if (menu) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [menu]);
  useEffect(() => {
    window.scrollTo(0, 0);
    setMenu(false);
    document.body.classList.remove("active");
    setShowCart(false);
  }, [location]);
  const close = (e) => {
    if (e.target === e.currentTarget) setMenu(false);
  };
  async function getActiveOpportunityCount() {
    try {
      const res = await campaignService.getCount();
      setNewNavigation({ campaigns_count: res.campaign_count });
    } catch (err) {
      console.error("Campaign count fetch error:", err);
      addToast({
        error: true,
        date: new Date(),
        msg: err.message || "Failed to fetch campaign count",
      });
    }
  }

  useEffect(() => {
    // getProfiles();
    getActiveOpportunityCount();
  }, []);

  useEffect(() => {
    if (cartItem.length > 0) {
    }
  }, [cartItem]);
  useEffect(() => {
    setShowCart(false);
  }, [closeCartFirsttime]);

  const goToPricing = () => {
    navigate("/brand/pricing");
  };
  const closeCartPanel = () => {
    setShowCart(!showCart);
  };
  const removeCartItem = (indexToRemove) => {
    let decryptedData = storageHandler.getCartItem();
    if (decryptedData !== null) {
      const storedCartItem = decryptData(decryptedData, secretKey);
      let getcartItem = [];
      let getcartItem_base =
        storedCartItem.length > 0 && JSON.parse(storedCartItem);
      getcartItem = getcartItem_base.filter(
        (item) => item.cart_item_addedBy === user.data.id
      );
      let savedCart = storedCartItem.length > 0 && JSON.parse(storedCartItem);
      if (savedCart.length > 0) {
        let userIdCart = getcartItem.filter(
          (itemOfCart, index) => index !== indexToRemove
        );
        const newItems = savedCart.filter(
          (item, index) => item.cart_item_addedBy !== user.data.id
        );
        const mergedArray = [...userIdCart, ...newItems];
        let encrypteddata = encryptData(JSON.stringify(mergedArray), secretKey);
        storageHandler.setCartItem(encrypteddata);
        setCartItem(mergedArray);
      }
    }
  };

  // async function getProfiles() {
  //   try {
  //     const res = await accountService.getProfiles({});
  //     if (res && res["data"]) {
  //       console.log(`🚀 ~ getProfiles ~ res["data"]:`, res["data"]);
  //       setProfiles(res["data"]["profiles"]);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }

  const decryptData = (cipherText, secretKey) => {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  };
  const encryptData = (data, secretKey) => {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  };
  const hideHeaderSidebar =
    path.indexOf("product_guidelines") > -1 ? true : false;

  return (
    <>
      <div className={impersonationBar ? "impersonationDivMargin" : ""}>
        {/* {!hideHeaderSidebar && (
          <>
            <Header
              setModal={setModal}
              menu={menu}
              setMenu={setMenu}
              user={user}
              profiles={profiles}
            />
            <Sidebar
              menu={menu}
              handleAnchorClick={handleAnchorClick}
              close={close}
              user={user}
              type={"brand"}
              newNavigation={newNavigation}
              impersonationBar={impersonationBar}
            />
          </>
        )} */}
        <AppLayout
          user={user}
          userInfo={userInfo}
          profiles={profiles}
          setModal={setModal}
          NotifModul={allNotifications}
          setModalNotification={setModalNotification}
          closeCartPanel={closeCartPanel}
          cartItem={cartItem}
          customTitle={customTitle}
          goToPricing={goToPricing}
        >
          <main>
            <Routes>
              <Route
                exact
                path="/billing"
                element={
                  <PrivateRoute>
                    <Billing
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      setCartItem={setCartItem}
                      cartItem={cartItem}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/profile"
                element={
                  <PrivateRoute>
                    <BrandProfile
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/"
                element={
                  <PrivateRoute>
                    <Billing
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/orderDetails/:id"
                element={
                  <PrivateRoute>
                    <OrderDetails
                      user={user}
                      goToPricing={goToPricing}
                      setOrderCreated={setOrderCreated}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      orderCreated={orderCreated}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/influencerlist"
                element={
                  <PrivateRoute>
                    <InfluencerList
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      locationData={locationData}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      setShowCart={setShowCart}
                      updateProfilePage={updateProfilePage}
                      setUpdateProfilePage={setUpdateProfilePage}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/assets"
                element={
                  <PrivateRoute>
                    <Assets
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      locationData={locationData}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/owl/:sessionId?"
                element={
                  <PrivateRoute>
                    <Owl
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      locationData={locationData}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/dashboard"
                element={
                  <PrivateRoute>
                    <BrandDashboard
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotify={setModalNotification}
                      setModalNotification={setModalNotification}
                      setModalNotificationData={setModalNotificationData}
                      accountCountNotification={accountCount}
                      updateNotificationStatus={updateNotificationStatus}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                      setModal={setModal}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/jobCampaigns"
                element={
                  <PrivateRoute>
                    <JobCampaigns
                      setShowConfirmModal={setShowConfirmModal}
                      setShowConfirmAction={setShowConfirmAction}
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      locationData={locationData}
                      saveCampaign={saveCampaign}
                      setSaveCampaign={setSaveCampaign}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                      setModal={setModal}
                      setCustomTitle={setCustomTitle}
                      onStartChat={(data) => setChatInfo(data)}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/jobpostmain"
                element={
                  <PrivateRoute>
                    <JobPostMain
                      setTab={() => navigate("/brand/jobCampaigns")}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/jobpostdescription"
                element={
                  <PrivateRoute>
                    <ProjectDescription />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/jobpostbrief"
                element={
                  <PrivateRoute>
                    <BriefFormWrapper />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/application"
                element={
                  <PrivateRoute>
                    <CampaignApplication
                      setShowConfirmModal={setShowConfirmModal}
                      setShowConfirmAction={setShowConfirmAction}
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      locationData={locationData}
                      saveCampaign={saveCampaign}
                      setSaveCampaign={setSaveCampaign}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      setModal={setModal}
                      setShowCart={setShowCart}
                      setCloseCartFirsttime={setCloseCartFirsttime}
                      userTypeRegOrNon={userTypeRegOrNon}
                      updateProfilePage={updateProfilePage}
                      goToPricing={goToPricing}
                    />
                  </PrivateRoute>
                }
              />

              <Route
                exact
                path="/campaigns"
                element={
                  <PrivateRoute>
                    <Campaigns
                      setShowConfirmModal={setShowConfirmModal}
                      setShowConfirmAction={setShowConfirmAction}
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      locationData={locationData}
                      saveCampaign={saveCampaign}
                      setSaveCampaign={setSaveCampaign}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                      setModal={setModal}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/recommendations"
                element={
                  <PrivateRoute>
                    <Recommend
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                    />
                  </PrivateRoute>
                }
              />

              <Route
                exact
                path="/influencerdiscovery"
                element={
                  <PrivateRoute>
                    <SearchInf
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/offers"
                element={
                  <PrivateRoute>
                    <Offer
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      onStartChat={(data) => setChatInfo(data)}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />

              <Route
                exact
                path="/review"
                element={
                  <PrivateRoute>
                    <BrandReview
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                      offerSelectedForReview={offerSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/frauddetectiontools"
                element={
                  <PrivateRoute>
                    <FraudDetectionTools
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                      offerSelectedForReview={offerSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/reports/*"
                element={
                  <PrivateRoute>
                    <Report
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                      setCustomTitle={setCustomTitle}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/orders"
                element={
                  <PrivateRoute>
                    <Order
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      goToPricing={goToPricing}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/influencerProfile/*"
                element={
                  <PrivateRoute>
                    <InfluencerProfile
                      user={user}
                      setModal={setModal}
                      setShowCart={setShowCart}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      setCartItem={setCartItem}
                      cartItem={cartItem}
                      setCloseCartFirsttime={setCloseCartFirsttime}
                      userTypeRegOrNon={userTypeRegOrNon}
                      updateProfilePage={updateProfilePage}
                      goToPricing={goToPricing}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/pricing"
                element={
                  <PrivateRoute>
                    <Pricing
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/placeorder"
                element={
                  <PrivateRoute>
                    <PlaceOrder
                      user={user}
                      goToPricing={goToPricing}
                      NotifModul={allNotifications}
                      setModal={setModal}
                      profiles={profiles}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      updateProfilePage={updateProfilePage}
                      setUpdateProfilePage={setUpdateProfilePage}
                      availableBalance={availableBalance}
                      showCart={showCart}
                      setShowCart={setShowCart}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      setOrderCreated={setOrderCreated}
                      setPaypalAmt={setPaypalAmt}
                      paypalAmt={paypalAmt}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/chat"
                element={
                  <PrivateRoute>
                    <Chat
                      goToPricing={goToPricing}
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      chatInfo={chatInfo}
                      onStartChat={(data) => setChatInfo(data)}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/briefing"
                element={
                  <PrivateRoute>
                    <Briefing
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      onStartChat={(data) => setChatInfo(data)}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                exact
                path="/product_guidelines"
                element={
                  <PrivateRoute>
                    <ProductGuidelines user={user} />
                  </PrivateRoute>
                }
              />

              <Route
                path="/infoPage1"
                element={
                  <PrivateRoute>
                    <InfoPage1
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      onStartChat={(data) => setChatInfo(data)}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="/tamacoin"
                element={
                  <PrivateRoute>
                    <BrandTamaCoin
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      onStartChat={(data) => setChatInfo(data)}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="/brandpage"
                element={
                  <PrivateRoute>
                    <BrandPage
                      goToPricing={goToPricing}
                      user={user}
                      setModal={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotification={setModalNotification}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                      onStartChat={(data) => setChatInfo(data)}
                      setOfferSelectedForReview={setOfferSelectedForReview}
                    />
                  </PrivateRoute>
                }
              />
              <Route
                path="*"
                element={
                  <PrivateRoute>
                    <BrandDashboard
                      user={user}
                      setModalSwitch={setModal}
                      profiles={profiles}
                      NotifModul={allNotifications}
                      setModalNotify={setModalNotification}
                      setModalNotification={setModalNotification}
                      setModalNotificationData={setModalNotificationData}
                      updateNotificationStatus={updateNotificationStatus}
                      closeCartPanel={closeCartPanel}
                      cartItem={cartItem}
                      setCartItem={setCartItem}
                    />
                  </PrivateRoute>
                }
              />
            </Routes>
          </main>
        </AppLayout>
      </div>
      {showCart && isAvailableBalnceLoaded && (
        <Cart
          user={user}
          updateProfilePage={updateProfilePage}
          setUpdateProfilePage={setUpdateProfilePage}
          setSubTotalAmt={setSubTotalAmt}
          subTotalAmt={subTotalAmt}
          setTotalToPay={setTotalToPay}
          totalToPay={totalToPay}
          availableBalance={availableBalance}
          showCart={showCart}
          setShowCart={setShowCart}
          cartItem={cartItem}
          removeCartItem={removeCartItem}
        />
      )}
      <AnimatePresence>
        {modal === "switch" && (
          <ModalSwitch
            changePage={changePage}
            setChangePage={setChangePage}
            profiles={profiles}
            close={() => setModal(null)}
          />
        )}
      </AnimatePresence>
      {toastList && <Toast list={toastList} setList={setToastList} />}
    </>
  );
}
